import React from 'react';
import { portal, Portal } from '../../../../Configs/general';

import ContractStepGDC from './ContractStep.GDC';

const ContractStep = props => {
  switch (portal) {
    case Portal.Gascaribe:
    case Portal.Gasguajira:
    case Portal.Efigas:
      return <ContractStepGDC {...props} />;
    default:
      return <></>;
  }
};

export default ContractStep;
